import { render, staticRenderFns } from "./DialogBotPicker.vue?vue&type=template&id=74af85fa&scoped=true&"
import script from "./DialogBotPicker.vue?vue&type=script&lang=js&"
export * from "./DialogBotPicker.vue?vue&type=script&lang=js&"
import style0 from "../style/bot-picker.scss?vue&type=style&index=0&id=74af85fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74af85fa",
  null
  
)

export default component.exports